<template src='./conciliationField.pug' lang='pug'></template>

<script>
import vSelect from 'vue-select'
import ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'

export default {
  name: 'ConciliationField',

  components: {
    vSelect,
    ButtonPrimary
  },

  props: {
    conciliationField: {
      type: Object,
      default: {}
    },
    attributesCfg: {
      type: Array,
      default: () => []
    },
    attributes: {
      type: Array,
      default: () => []
    },
    conciliationFields: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      field: null
    }
  },

  watch: {
    conciliationField: {
      handler (newVal, oldVal) {
        this.field = newVal
      },
      deep: true
    }
  },

  methods: {
    changeAttCfg (cfg) {
      if (cfg === null || cfg instanceof Object) {
        this.$emit('change-conc-field-cfg', { cfg, concField: this.conciliationField })
      }
    },

    changeAttName (att) {
      if (att instanceof Object) {
        this.$emit('change-conc-field-att-name', { att, concField: this.conciliationField })
      }
    },

    changeConcField (field) {
      if (field instanceof Object) {
        this.$emit('change-conc-field', { field, concField: this.conciliationField })
      }
    },

    removeField () {
      this.$emit('remove-field-from-criteria', this.conciliationField)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ConciliationField.vue?3ecb56b5